import { VCard } from 'vuetify/lib/components/VCard';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTextField } from 'vuetify/lib/components/VTextField';

import "core-js/modules/es.function.name.js";
var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c(VDialog, {
    attrs: {
      width: "60rem"
    },
    on: {
      keydown: function keydown($event) {
        if (!$event.type.indexOf("key") && _vm._k($event.keyCode, "esc", 27, $event.key, ["Esc", "Escape"])) return null;
        return _vm.cancel.apply(null, arguments);
      }
    },
    model: {
      value: _vm.dialog,
      callback: function callback($$v) {
        _vm.dialog = $$v;
      },
      expression: "dialog"
    }
  }, [_c(VCard, {
    staticClass: "contact-dialog"
  }, [_c("div", {
    staticClass: "dialog-closer"
  }, [_c(VIcon, {
    staticClass: "far fa-times-circle",
    on: {
      click: _vm.cancel
    }
  })], 1), _c("div", {
    staticClass: "user-infos"
  }, [_c("h2", [_vm._v("User information")]), _c("div", {
    staticClass: "user-infos-details"
  }, [_c("div", [_c(VTextField, {
    attrs: {
      label: "Name",
      placeholder: "John",
      readonly: ""
    },
    model: {
      value: _vm.contact.name,
      callback: function callback($$v) {
        _vm.$set(_vm.contact, "name", $$v);
      },
      expression: "contact.name"
    }
  })], 1), _c("div", [_c(VTextField, {
    attrs: {
      label: "Email",
      placeholder: "john.doe@domain.com",
      readonly: ""
    },
    model: {
      value: _vm.contact.email,
      callback: function callback($$v) {
        _vm.$set(_vm.contact, "email", $$v);
      },
      expression: "contact.email"
    }
  })], 1)])]), _c("div", {
    staticClass: "contact-infos"
  }, [_c("h2", [_vm._v("User request")]), _c("div", [_c(VTextField, {
    attrs: {
      label: "Subject",
      placeholder: "Subject of your request",
      readonly: ""
    },
    model: {
      value: _vm.contact.subject,
      callback: function callback($$v) {
        _vm.$set(_vm.contact, "subject", $$v);
      },
      expression: "contact.subject"
    }
  })], 1), _c("div", {
    staticClass: "form-message",
    domProps: {
      innerHTML: _vm._s(String.nl2br(_vm.contact.message))
    }
  })])])], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };